<script setup>
// ============================================================================
// BonBoZ: BIỂU ĐỒ TRÒN (doughnut) cho trang Thẻ — kiểu Pancake.
//
// Chỉ vẽ hình; chú giải và con số ở giữa do trang cha đặt (chữ giữa là HTML
// đè lên canvas — dễ style và dịch hơn plugin vẽ chữ của chart.js nhiều).
//
// Màu của từng miếng là MÀU NGƯỜI DÙNG ĐẶT cho thẻ ở Cài đặt → Nhãn, truyền
// vào theo từng dòng — cùng lý do với các thanh ngang: nhìn thẻ ở đâu cũng
// phải ra cùng một màu.
// ============================================================================
import { computed } from 'vue';
import { Chart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  ArcElement,
  DoughnutController,
  Tooltip,
} from 'chart.js';

const props = defineProps({
  // [{ tag, so, nen }]
  dong: { type: Array, default: () => [] },
});

// Đăng ký NGAY KHI NẠP MODULE, không phải trong onMounted như
// `BieuDoCotDuong.vue`: onMounted của component CHA chạy SAU onMounted của
// con, mà `<Chart>` (con) dựng biểu đồ ngay trong onMounted của nó — lúc đó
// DoughnutController chưa đăng ký, chart.js ném lỗi và canvas trắng vĩnh
// viễn. Bên BieuDoCotDuong thoát nạn một cách tình cờ vì dữ liệu về sau qua
// fetch nên biểu đồ dựng lại lần nữa; ở đây component chỉ mount khi dữ liệu
// ĐÃ có, không có lần thứ hai nào cả.
ChartJS.register(ArcElement, DoughnutController, Tooltip);

const duLieu = computed(() => ({
  labels: props.dong.map(x => x.tag),
  datasets: [
    {
      data: props.dong.map(x => x.so),
      backgroundColor: props.dong.map(x => x.nen),
      // Không kẻ viền giữa các miếng: viền mặc định màu trắng, sang nền tối
      // thành những khe sáng chói.
      borderWidth: 0,
    },
  ],
}));

const tuyChon = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '68%',
  plugins: { legend: { display: false } },
};
</script>

<template>
  <Chart type="doughnut" :data="duLieu" :options="tuyChon" />
</template>
